import { render, staticRenderFns } from "./InstructorList.vue?vue&type=template&id=227ba146&scoped=true&"
import script from "./InstructorList.vue?vue&type=script&lang=js&"
export * from "./InstructorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ba146",
  null
  
)

export default component.exports